import { Component, Input, OnInit } from '@angular/core';
import { RuleActionExtension } from '@sabstravtech/obtservices/base';
import { WithSubscriptionComponent } from '@sabstravtech/obtservices/angular';

import { resultIcons } from '../../../core/enum/result-icons.enum';

@Component({
  selector: 'app-warning-tags[ticket]',
  templateUrl: './warning-tags.component.html',
  styleUrls: ['./warning-tags.component.scss'],
  standalone: false
})
export class WarningTagsComponent extends WithSubscriptionComponent implements OnInit {
  @Input() ticket: RuleActionExtension;
  @Input() displayCheck = false;
  @Input() isUnavailableOnly = false;
  @Input() iconId;
  resultItemType = resultIcons;
  messages: string;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.messages =
      typeof this.ticket.requiresReasonMessages === 'string'
        ? this.ticket.requiresReasonMessages
        : this.ticket.requiresReasonMessages?.join(', ') || '';
  }
}
